export const companySettingsMostUsedEventsAndAttributesByAppsAndAppGroups =
  "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups";
